<template>
    <span v-tooltip="tooltipOptions" class="icon" :style="stylesIcon">
        <font-awesome-layers v-if="dot" fixed-width>
            <font-awesome-icon
                :border="border"
                :fixed-width="fixedWidth"
                :flip="flip"
                :icon="icon"
                :mask="mask"
                :list-item="listItem"
                :pull="pull"
                :pulse="pulse"
                :rotation="rotation"
                :size="size"
                :spin="spin"
                :transform="transform"
                :symbol="symbol"
                :style="stylesSvg"
            />
            <span class="fa-layers-counter">&nbsp;</span>
        </font-awesome-layers>

        <font-awesome-layers v-else-if="count" fixed-width>
            <font-awesome-icon
                :border="border"
                :fixed-width="fixedWidth"
                :flip="flip"
                :icon="icon"
                :mask="mask"
                :list-item="listItem"
                :pull="pull"
                :pulse="pulse"
                :rotation="rotation"
                :size="size"
                :spin="spin"
                :transform="transform"
                :symbol="symbol"
                :style="stylesSvg"
            />
            <span class="fa-layers-counter" v-text="count >= 99 ? '99+' : count" />
        </font-awesome-layers>

        <font-awesome-icon
            v-else
            :border="border"
            :fixed-width="fixedWidth"
            :flip="flip"
            :icon="icon"
            :mask="mask"
            :list-item="listItem"
            :pull="pull"
            :pulse="pulse"
            :rotation="rotation"
            :size="size"
            :spin="spin"
            :transform="transform"
            :symbol="symbol"
            :style="stylesSvg"
        />
    </span>
</template>

<script>
export default {
    props: {
        border: {
            type: Boolean,
            default: false,
        },
        count: {
            type: Number,
            default: null,
        },
        dot: {
            type: Boolean,
            default: false,
        },
        fixedWidth: {
            type: Boolean,
            default: false,
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
        flip: {
            type: String,
            default: null,
            validator: (value) => ['horizontal', 'vertical', 'both'].indexOf(value) > -1,
        },
        icon: {
            type: [Object, Array, String],
            required: true,
        },
        mask: {
            type: [Object, Array, String],
            default: null,
        },
        listItem: {
            type: Boolean,
            default: false,
        },
        pull: {
            type: String,
            default: null,
            validator: (value) => ['right', 'left'].indexOf(value) > -1,
        },
        pulse: {
            type: Boolean,
            default: false,
        },
        rotation: {
            type: Number,
            default: null,
            validator: (value) => [90, 180, 270].indexOf(value) > -1,
        },
        size: {
            type: String,
            default: null,
            validator: (value) =>
                [
                    'lg',
                    'xs',
                    'sm',
                    '1x',
                    '2x',
                    '3x',
                    '4x',
                    '5x',
                    '6x',
                    '7x',
                    '8x',
                    '9x',
                    '10x',
                ].indexOf(value) > -1,
        },
        customSize: {
            type: [Number, Array],
            default: 12,
        },
        spin: {
            type: Boolean,
            default: false,
        },
        transform: {
            type: [String, Object],
            default: null,
        },
        symbol: {
            type: [Boolean, String],
            default: false,
        },
        tooltip: {
            type: [Object, String, null],
            default: '',
        },
    },

    computed: {
        tooltipOptions() {
            if (typeof this.tooltip === 'string') return this.tooltip;

            return {
                ...this.tooltip,
                container: 'body',
                boundary: 'body',
                html: true,
                autoHide: false,
            };
        },

        stylesSvg() {
            if (this.fullWidth) {
                return {
                    width: '100%',
                    height: '100%',
                };
            }

            return false;
        },

        stylesIcon() {
            if (this.fullWidth) {
                if (Array.isArray(this.customSize)) {
                    const width = this.customSize[0];
                    const height = this.customSize[1] || this.customSize[0];

                    return {
                        width: `${width}px`,
                        height: `${height}px`,
                    };
                }

                return {
                    'font-size': `${this.customSize}px`,
                };
            }

            return false;
        },
    },
};
</script>
